import type { Response } from "@/types/global"
import { HttpRequest } from "@/utils/request"

export interface DashboardStats {
  users: number
  dictionary: {
    headwords: number
    phrasalVerbs: number
    collocations: number
    idioms: number
    total: number
  }
  sets: number
  vocabularies: number
}

export const dashboardService = {
  getStats() {
    return HttpRequest.get("v1/dashboard/stats").json<Response<DashboardStats>>()
  },
}
